module.exports = __webpack_public_path__ + "img/tab-4.70ff72b7.png";